/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersUpdateByDownstream } from '../../models/members-update-by-downstream';
import { MembersWithTeamValidation } from '../../models/members-with-team-validation';

export interface UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Params {
  orgId: string;
  org: string;
      body: MembersUpdateByDownstream
}

export function updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch(http: HttpClient, rootUrl: string, params: UpdateUpstreamOrganizationApiV2MembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithTeamValidation>> {
  const rb = new RequestBuilder(rootUrl, updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch.PATH, 'patch');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithTeamValidation>;
    })
  );
}

updateUpstreamOrganizationApiV2MembersOrgIdProfilePatch.PATH = '/api/v2/members/{orgId}/profile';
